/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { Button, Divider, Input, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, Tooltip, Select, SelectItem, } from '@nextui-org/react';
import toast from 'react-hot-toast';
import { copy, Constants } from '../../../../utils';
import { TeacherGroupService } from '../../../../services';
import { IconTrash } from '@tabler/icons-react';
import { useSelector } from 'react-redux';


const MODAL_ACTION = {
  DELETE: 1,
}

const TYPES_EDUCATION = [
  { value: Constants.TYPES_EDUCATION.INITIAL, label: 'Inicial'},
  { value: Constants.TYPES_EDUCATION.PRIMARY, label: 'Primaria'},
  { value: Constants.TYPES_EDUCATION.MEDIA_GENERAL, label: 'Media General'},
]

const ModalCreateSection = ({ item, onSuccess, onClose, currentSchoolYearId }) => {
  const [selectedItem, setSelectedItem] = useState();
  const [modalAction, setModalAction] = useState(MODAL_ACTION.NONE);
  const { addSection, form, onChange, onSubmit, removeSection } = useForm(item, currentSchoolYearId);

  const submit = async () => {
    const isSuccess = await onSubmit();
    if (isSuccess) onSuccess();
  }

  const onSelectItem = (action, item = null) => {
    setSelectedItem(item);
    setModalAction(action);
  }


  const closeModal = () => {
    setSelectedItem(null);
    setModalAction(MODAL_ACTION.NONE);
  }

  const onDeleteSection = () => {
    const { idx, ...rest } = selectedItem
    removeSection(rest, idx);
    closeModal();
  }


  return (
    <>
      <Modal
        size="sm"
        isOpen={modalAction !== MODAL_ACTION.NONE}
        onClose={() => closeModal()}
        backdrop="blur"
        scrollBehavior="outside"
      >
        <ModalContent>
          {(onClose) => {
            if (modalAction === MODAL_ACTION.DELETE) return (
              <ModalDeleteSection
                section={selectedItem}
                onClose={onClose}
                onDelete={onDeleteSection}
              />
            );
          }}
        </ModalContent>
      </Modal>

      <ModalHeader className="flex flex-col gap-1">{item ? 'Editar Sección' : 'Agregar Sección'}</ModalHeader>
      <ModalBody className="gap-8">
        <div className="flex flex-col flex-1 gap-4">
          <Input
            label="Grado"
            labelPlacement="outside"
            placeholder=" "
            radius="sm"
            variant="bordered"
            value={form.name}
            onValueChange={v => onChange(v, 'name')}
          />

          <Select
            label="Nível"
            labelPlacement="outside"
            placeholder=" "
            variant="bordered"
            radius="sm"
            disallowEmptySelection
            selectedKeys={form.type ? new Set([String(form.type)]) : new Set()}
            onSelectionChange={(keys) => {
              const value = Array.from(keys)[0]; // string
              onChange(value ? Number(value) : '', 'type'); // lo guardas como number
            }}
          >
            {TYPES_EDUCATION.map((item) => (
              <SelectItem key={String(item.value)} value={String(item.value)}>
                {item.label}
              </SelectItem>
            ))}
          </Select>

          <p className='font-bold text-sm'>Secciones</p>

          <div className="flex flex-col gap-2 text-sm font-medium">
            {form.sections.map((section, sectionIdx) => (
              <div key={sectionIdx} className="flex justify-between items-center gap-4">
                <Input
                  label=""
                  labelPlacement="outside"
                  placeholder=" "
                  radius="sm"
                  variant="bordered"
                  value={form.sections[sectionIdx].name ?? ''}
                  onValueChange={v => onChange(v, '_section', sectionIdx)}
                />
                <Tooltip content="Eliminar" color="danger">
                  <IconTrash className="text-danger" onClick={() => {
                    if (!section.id) return removeSection(null, sectionIdx);
                    onSelectItem(MODAL_ACTION.DELETE, { ...section, idx: sectionIdx });
                  }} />
                </Tooltip>
              </div>
            ))}
          </div>

          <Button
            className='bg-green text-white w-16'
            onClick={addSection}
          //isDisabled={!form._grade || !form._section}
          >
            Agregar
          </Button>

          <Divider />




        </div>
      </ModalBody>
      <ModalFooter>
        <Button variant="light" onPress={onClose}>Cerrar</Button>
        <Button className="bg-green" color="primary" onPress={submit}>Guardar</Button>
      </ModalFooter>
    </>
  )
}


const ModalDeleteSection = ({ section, onClose, onDelete }) => {
  return (
    <>
      <ModalHeader className="flex flex-col gap-1">Confirmación</ModalHeader>
      <ModalBody>
        <p className="text-center">¿Estás seguro de eliminar esta sección? <span className='font-bold'>{section?.name}</span>. Puede que posea registros de horarios y materias asociadas, al eliminarse se eliminarán también dichos registros.</p>
      </ModalBody>
      <ModalFooter className="justify-evenly">
        <Button variant="light" onPress={onClose}>Cancelar</Button>
        <Button color="danger" onPress={onDelete}>Aceptar</Button>
      </ModalFooter>
    </>
  )
}

const useForm = (item, currentSchoolYearId) => {
  const initialForm = {
    id: null,
    name: '',
    type: '',
    _section: '',
    sections: [],
    deleteSections: [],
  };
  const user = useSelector(state => state.user);
  const [form, setForm] = useState(initialForm);

  const onChange = (value, target, index) => {
    if (target === '_section') {
      const _form = copy(form);
      _form.sections[index].name = value;
      return setForm(_form);
    }
    setForm(s => ({ ...s, [target]: value }));
  }

  const addSection = () => {
    setForm(s => ({
      ...s,
      _section: '',
      sections: [
        ...s.sections,
        {
          id: null,
          name: '',
        }
      ]
    }));
  }

  const removeSection = (section, idx) => {
    if (section) {
      setForm(s => ({
        ...s,
        deleteSections: [...s.deleteSections, section],
      }))
    }
    setForm(s => ({
      ...s,
      sections: s.sections.filter((x, i) => i !== idx)
    }));
  }

  const onError = (msg) => {
    toast.error(msg);
    return false;
  }

  const isValidForm = () => {
    if (!form.name) {
      onError('Debe indicar el nombre del grado');
      return false;
    }

    if (!form.type) {
      onError('Debe indicar el nível educacional');
      return false;
    }

    if (!form.sections.length) {
      onError('Debe indicar al menos una sección');
      return false;
    }

    if (form.sections.some(section => section.name?.trim()?.length === 0)) {
      onError('Debe llenar todas las secciones');
      return false;
    }

    return true;
  }

  const onSubmit = async () => {
    if (!isValidForm()) return;
    try {
      const crateData = {
        professor_id: user.id,
        school_year_id: currentSchoolYearId,
        sections: form.sections.map(section => ({ name: section.name, school_grade_name: form.name, school_grade_type: form.type, }))
      }


      item
        ? await TeacherGroupService.groups.updateSections({ ...form, professor_id: user.id, school_year_id: currentSchoolYearId, })
        : await TeacherGroupService.groups.createSections(crateData)
      toast.success(`Grado ${item ? 'editado' : 'creado'} correctamente`);
      return true
    } catch (error) {
      onError(String(error));
      return false;
    }
  }

  useEffect(() => {
    if (item) {
      setForm(s => ({
        ...s,
        ...item
      }))
    } else {
      addSection()
    }
  }, [item])


  return {
    addSection,
    form,
    onChange,
    onSubmit,
    removeSection,
  }
}

export default ModalCreateSection;
